/**
 * Checkout Screen
 * @author    ThemesBuckets <themesbuckets@gmail.com>
 * @copyright Copyright (c) 2020
 * @license   AppsPlaces
 */

import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit {

  steps: any = [];
  cards: any = [];

  constructor(public modalController: ModalController,
    private router: Router) { }

  ngOnInit() {}

  // Go to order page function
  gotoOrderPage() {
    this.dismiss();
    this.router.navigate(['/tabs/orders']);
  }

  // Go to product page
  gotoProductsPage() {
    this.dismiss();
    this.router.navigate(['/tabs/products']);
  }

  // Back to previous screen
  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    })
  }

}
